import React from "react"
import { Grid, Button, Typography, Box } from "@mui/material"
import { Link } from "react-router-dom"


import {  ButtonGrid, rootStyles, BoxLabelA, HomePageButtons, GridButton, LinkButtons, BoxLabelB, BoxLabelC, BoxLabelD } from "../styles/BuildingStyles"

function HomePage() {
    

    return (
        <Box sx={rootStyles}>
            <Grid container alignContent="center" direction="column">
                <Typography sx={BoxLabelA}> US BUILDING 100 </Typography>
                <Grid
                    container
                    align="center"
                    sx={HomePageButtons}
                >
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/ben-nevis"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    BEN NEVIS
                                </Button>
                                

                            </Link>
                    </Grid>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/everest"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    EVEREST
                                </Button>
                            </Link>
                        
                    </Grid>
                </Grid>

                <Typography sx={BoxLabelB}> US BUILDING 120 </Typography>
                <Grid container sx={HomePageButtons}>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link 
                                to={"/k2"} 
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    K2
                                </Button>
                            </Link>
                        
                    </Grid>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/the-excellence-room"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    The Excellence Room
                                </Button>
                            </Link>
                        
                    </Grid>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                       
                            <Link
                                to={"/mount-marcy"}
                                sx={LinkButtons}
                            >
                                 <Button variant="contained" color='secondary'> 
                                    Mount Marcy
                                 </Button>
                            </Link>
                        
                    </Grid>
                </Grid>

                <Typography sx={BoxLabelC}> US BUILDING 170 </Typography>
                <Grid container sx={HomePageButtons}>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/matterhorn"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    Matterhorn
                                </Button>
                            </Link>
                        
                    </Grid>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/mont-blanc"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    Mont Blanc
                                </Button>
                            </Link>
                        
                    </Grid>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/pikes-peak"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    Pikes Peak
                                </Button>
                            </Link>
                        
                    </Grid>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/training-room"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    Training Room
                                </Button>
                            </Link>
                        
                    </Grid>
                </Grid>
                <Typography sx={BoxLabelD}> SWITZERLAND </Typography>
                <Grid container sx={HomePageButtons}>
                    <Grid
                        item
                        size={6}
                        align="center"
                        sx={GridButton}
                    >
                        
                            <Link
                                to={"/chasseral"}
                                sx={LinkButtons}
                            >
                                <Button variant="contained" color='secondary'>
                                    Chasseral
                                </Button>
                            </Link>
                        
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default HomePage
